import { images } from "../../constants";

const projects = [
  {
    id: 1,
    image: images.about05,
    title: "Easybank-Landing-Page",
    tags: "web development",
    projectLink: "https://easybank-page-frontend-mentor-akash.netlify.app/",
    codeLink: "https://github.com/AKASHGOWDA-007/Easybank-landing-page",
    description: "Frontend Mentor Challenge",
  },
  {
    id: 2,
    image: images.about01,
    title: "ToDo List App",
    tags: "web development",
    projectLink: "https://to-do-list-app-0-1.netlify.app/",
    codeLink: "https://github.com/AKASHGOWDA-007/ToDo-List-App",
    description:
      "Todo list is a task list app. Adding & removing tasks is quick and easy.",
  },
  {
    id: 6,
    image: images.about06,
    title: "Chat GPT Landing Page",
    tags: "ReactJs",
    projectLink: "https://chatgpt-landing-page.netlify.app/",
    codeLink: "https://github.com/AKASHGOWDA-007/chatgpt-landing-page",
    description: "",
  },
  {
    id: 3,
    image: images.about02,
    title: "Random Quote Generator",
    tags: "web development",
    projectLink: "https://inspirational-quote-generator-app.netlify.app/",
    codeLink: "https://github.com/AKASHGOWDA-007/random-quote-generator",
    description:
      "In this quote app, each time you click on the new quote button you'll get a new quote.",
  },

  {
    id: 5,
    image: images.about04,
    title: "Starbucks-Landing-Page",
    tags: "UI/UX",
    projectLink: "https://starbucks-landing-page1.netlify.app/#",
    codeLink: "https://github.com/AKASHGOWDA-007/Starbucks-Landing-Page",
    description: "",
  },

  {
    id: 4,
    image: images.about03,
    title: "Online Food Delivery Website",
    tags: "UI/UX",
    projectLink:
      "https://akashgowda-007.github.io/Online-Food-Delivery-Website/",
    codeLink: "https://github.com/AKASHGOWDA-007/Online-Food-Delivery-Website",
    description: "Get instant delivery of your favourite food",
  },
];

export { projects };
